<template>
    <div class="receipt-list-view">
        <!-- 搜索项 -->
        <Row type="flex">
            <div class="flex-child">
                <span class="input-label">选择部门</span>
                <span class="Cascader">
                    <Cascader :data="departmentData"
                        v-model="department"
                        @on-change="getCascader"
                        change-on-select></Cascader>
                </span>
            </div>
            <div class="flex-child">
                结算渠道：
                <Select v-model="settleChannel" style="width:100px;" @on-change="getSettleChannel">
                    <Option v-for="item in settleChannelList" :key="item.value" :value="item.value">{{ item.label }}</Option>
                </Select>
            </div>
            <div class="flex-child">
                <span class="input-label">开始日期</span>
                <DatePicker
                    type="date"
                    placeholder="选择日期"
                    :options="options1"
                    v-model="startDate"
                    @on-change="getFormatStartDate">
                </DatePicker>
            </div>
            <div class="flex-child">
                <span class="input-label">结束日期</span>
                <DatePicker
                    type="date"
                    placeholder="选择日期"
                    :options="options2"
                    v-model="endDate"
                    @on-change="getFormatEndDate"></DatePicker>
            </div>
            <div class="flex-child">
                状态查询：
                <Select v-model="completeIndex" style="width:100px;" @on-change="getCompleteState">
                    <Option v-for="item in completeLsit" :key="item.value" :value="item.value">{{ item.label }}</Option>
                </Select>
                <Checkbox v-model="single" @on-change="singleChange">包含作废</Checkbox>
            </div>
            <div class="flex-child">
                <Button type="primary" :loading="checkLoading">
                    <span v-if="!checkLoading" @click="checkList">查询</span>
                    <span v-else>查询...</span>
                </Button>
                <Button :loading="exportLoading">
                    <span v-if="!exportLoading" @click="exportExls">导出</span>
                    <span v-else>正在导出</span>
                </Button>
            </div>
        </Row>

        <!-- 新建项 -->
        <div class="receipts-operation">
            <Button class="operation-btn">
                <a href="javascript:;" @click="openProject" v-if="projectStatus !== '1' && this.quotationStatus === '1'">手动新建单据</a>
                <router-link :to="{path: '/index/manualBuild', query: {projectStatus, type: 'home'}}" v-else>手动新建单据</router-link>
            </Button>
            <Button class="operation-btn" v-if="projectStatus !== '1' && quotationStatus !== '1'">
                <router-link :to="{path: '/index/modelBuild', query: {type: 'model'}}">模板新建单据</router-link>
            </Button>
            <Button class="operation-btn">
                <router-link :to="{path: '/index/modelBuild', query: {type: 'history'}}"  v-if="projectStatus !== '1'">引用历史单据</router-link>
                <a href="javascript:;" @click="openProject" v-else>引用历史单据</a>
            </Button>

            <div class="flex-child-input">
                <Input v-model="filterWord"
                    placeholder="请输入单据号搜索">
                    <Button slot="append" @click="search">搜索</Button>
                </Input>
            </div>
        </div>

        <!-- 表格 -->
        <Table :columns="columns12" :row-class-name="rowClassName" :data="receiptData" :loading="loading" :height="520">
            <template slot-scope="{ row }" slot="action">
                <div style="margin-left: -30px; margin-right: -30px">
                    <Button type="error" size="small" @click="removeNo(1, row.originNo)" v-if="row.destroyStatus !== 1">删除</Button>
                    <Button type="primary" size="small"
                        @click="removeNo(2, row.originNo)"
                        v-if="row.destroyStatus !== 1 || row.originStatus === 1"
                        style="margin-left: 2px;">撤回</Button>
                    <Button type="primary" size="small"
                        @click="revisionNo(row)"
                        v-if="row.destroyStatus !== 1 || row.originStatus === 1"
                        style="margin-left: 2px;">重新修改</Button>
                    <Button type="primary" size="small"
                        @click="resetData(row.originNo)"
                        v-if="isTb && row.sync === 2"
                        style="margin-left: 2px;">同步</Button>
                </div>
            </template>
            <template slot-scope="{ row }" slot="originNo">
                <span class="is-router-link" @click="checkReceiptDetail(row)">{{ row.originNo }}</span>
            </template>
            <template slot-scope="{ row }" slot="postAt">
                <span>{{ row.postAt === 'Invalid date' ? '' : row.postAt }}</span>
            </template>
            <template slot-scope="{ row }" slot="originStatus">
                <span v-if="row.originStatus === 2">已完成</span>
                <span v-else>未完成</span>
            </template>
            <template slot-scope="{ row }" slot="destroyStatus">
                <span v-if="row.destroyStatus === 1">正常</span>
                <span v-else>打回</span>
            </template>
        </Table>
        <!-- 导出表格 -->
        <Table :columns="columns13" :data="exportData" id="Elsx-download">
            <template slot-scope="{ row }" slot="originNo">
                <span class="is-router-link">{{ row.originNo }}</span>
            </template>
            <template slot-scope="{ row }" slot="postAt">
                <span>{{ row.postAt === 'Invalid date' ? '' : row.postAt }}</span>
            </template>
            <template slot-scope="{ row }" slot="originStatus">
                <span v-if="row.originStatus === 2">已完成</span>
                <span v-else>未完成</span>
            </template>
            <template slot-scope="{ row }" slot="destroyStatus">
                <span v-if="row.destroyStatus === 1">正常</span>
                <span v-else>订单销毁</span>
            </template>
        </Table>

        <!-- 总量 -->
        <div class="total-info">
            <span>物资总量： <b>{{ orderAllCount }}</b></span>
            <span>物资总价： <b>￥{{ orderAllPrice }}元</b></span>
        </div>

        <!-- 分页 -->
        <div class="pages-box">
            <Page
                :current="condis.pageNumber"
                :total="totalList"
                show-sizer
                :page-size="condis.pageSize"
                @on-change="getChangePageNum"
                @on-page-size-change="getChangePageSize"/>
        </div>
        <!--  -->
        <Modal
            class="model-postion-setting"
            v-model="model"
            :title="modelTitle">
            <div class="history-order">
                <span>{{modelContent}}</span>
            </div>
            <template slot="footer">
                <span class="his-cancel" @click="model = false">取消</span>
                <span class="his-ok" @click="submit">确定</span>
            </template>
        </Modal>
        <!-- 计划 -->
        <Modal
            class="model-postion-setting"
            v-model="openProjectModal"
            :title="modalTitle">
            <div class="history-order" style="padding-bottom: 20px">
                {{modalTitle}}：
                <Select v-model="selectProject" style="width:202px;">
                    <Option v-for="item in projectList" :key="item.value" :value="item.value">{{ item.label }}</Option>
                </Select>
            </div>
            <template slot="footer">
                <span class="his-cancel" @click="openProjectModal = false">取消</span>
                <span class="his-ok" @click="submitProject">确定</span>
            </template>
        </Modal>
        <Modal
            class="model-postion-tip model-postion-setting"
            v-model="tipModel"
            :mask-closable="false"
            :closable="false"
            title="公告">
            <div class="history-order">
                <p class="text-title">尊敬的客户：</p>
                <p class="text-space">因近期护网安全检查，厂里临时关停了物资系统服务器，目前厂里物资系统暂时无法正常使用，导致供应商系统录入的单据暂时无法推送至厂里物资系统。</p>
                <p class="text-space">请各位正常在供应商系统内录入单据。系统恢复时间另行通知，待系统恢复后，大家在单据列表点击同步按钮进行推送。</p>
            </div>
            <template slot="footer">
                <span class="his-ok" @click="closeTipModel">关闭</span>
            </template>
        </Modal>
    </div>
</template>

<script>
import { selectAllOriginalInfo, deleteOriginalInfo, rejectOriginalInfo, getAllSettleChannel, updateOriginalSync, getMyProjects } from '@/graphql/graphql.js';
import { getMonthFirstDay } from '@/utils/date.js';
import { cliqueNoData } from '@/assets/js/data.js';
import Cookies from 'js-cookie';
import factory from '@/assets/js/ybTool.js';
import '@/assets/js/query.min.js';
import '@/assets/js/jszip.min.js';
export default {
    data() {
        const self = this;
        return {
            // 单据列表加载中状态
            loading: false,

            // 查询加载中状态
            checkLoading: false,

            // 导出加载中状态
            exportLoading: false,
            single: true,
            // 部门 && 部门列表
            department: [],
            departmentData: [],
            timeOut: null,
            timerId: null,

            // 状态查询
            completeIndex: 0,
            completeLsit: [
                {
                    label: '全部',
                    value: 0
                },
                {
                    label: '未完成',
                    value: 1
                },
                {
                    label: '已完成',
                    value: 2
                }
            ],

            // 查询参数
            condis: {
                organNo: '',
                settleChannel: '',
                startTime: getMonthFirstDay(),
                endTime: getMonthFirstDay(new Date().getDate()),
                originNo: '',
                pageNumber: 1,
                pageSize: 20,
                isDraft: false
            },

            // 分页 全数
            totalList: 0,

            // 选择日期
            startDate: getMonthFirstDay(),
            endDate: getMonthFirstDay(new Date().getDate()),
            options1: {
                disabledDate(date) {
                    return date && date.valueOf() > Date.now();
                }
            },
            options2: {
                disabledDate(date) {
                    return date && date.valueOf() < self.getTimeBegin();
                }
            },

            // 搜索
            filterWord: '',

            columns12: [
                {
                    title: '操作',
                    slot: 'action',
                    width: 200,
                    align: 'center'
                },
                {
                    title: '原始单号',
                    key: 'originNo',
                    slot: 'originNo',
                    className: 'info-color',
                    width: 170
                },
                {
                    title: '结算渠道',
                    key: 'settleChannel',
                    width: 100
                },
                {
                    title: '状态',
                    key: 'destroyStatus',
                    slot: 'destroyStatus',
                    width: 70
                },
                {
                    title: '原始单据状态',
                    key: 'originStatus',
                    slot: 'originStatus',
                    width: 120
                },
                {
                    title: '组织部门',
                    key: 'path',
                    width: 350
                },
                {
                    title: '项目数',
                    key: 'originalItemsCount',
                    width: 100
                },
                {
                    title: '物资数量',
                    key: 'productCount',
                    width: 100
                },
                {
                    title: '金额',
                    key: 'orderAmount',
                    width: 100
                },
                {
                    title: '订单号',
                    key: 'docNo',
                    width: 170
                },
                {
                    title: '订单状态',
                    key: 'orderStatus',
                    width: 100
                },
                {
                    title: '冲销单号',
                    key: 'destroyOriginNo',
                    width: 170
                },
                {
                    title: '提交时间',
                    key: 'submitAt',
                    width: 150
                },
                {
                    title: '创建时间',
                    key: 'createdAt',
                    width: 150
                },
                {
                    title: '修改时间',
                    key: 'updatedAt',
                    width: 150
                },
                {
                    title: '过账时间',
                    key: 'postAt',
                    slot: 'postAt',
                    width: 150
                }
            ],
            columns13: [
                {
                    title: '原始单号',
                    key: 'originNo',
                    slot: 'originNo',
                    width: 170
                },
                {
                    title: '结算渠道',
                    key: 'settleChannel',
                    width: 120
                },
                {
                    title: '状态',
                    key: 'destroyStatus',
                    slot: 'destroyStatus',
                    width: 70
                },
                {
                    title: '原始单据状态',
                    key: 'originStatus',
                    slot: 'originStatus',
                    width: 120
                },
                {
                    title: '组织部门',
                    key: 'path',
                    width: 350
                },
                {
                    title: '项目数',
                    key: 'originalItemsCount',
                    width: 100
                },
                {
                    title: '物资数量',
                    key: 'productCount',
                    width: 100
                },
                {
                    title: '金额',
                    key: 'orderAmount',
                    width: 100
                },
                {
                    title: '订单号',
                    key: 'docNo',
                    width: 170
                },
                {
                    title: '订单状态',
                    key: 'orderStatus',
                    width: 100
                },
                {
                    title: '冲销单号',
                    key: 'destroyOriginNo',
                    width: 170
                },
                {
                    title: '提交时间',
                    key: 'submitAt',
                    width: 150
                },
                {
                    title: '创建时间',
                    key: 'createdAt',
                    width: 150
                },
                {
                    title: '修改时间',
                    key: 'updatedAt',
                    width: 150
                },
                {
                    title: '过账时间',
                    key: 'postAt',
                    slot: 'postAt',
                    width: 150
                }
            ],

            receiptData: [],
            exportData: [],

            // 物资合计
            orderAllCount: 0,
            orderAllPrice: 0,
            orderId: '',
            model: false,
            settleChannelList: [],
            settleChannel: 'D00',
            isClique: false,
            projectStatus: '',
            quotationStatus: '',
            openProjectModal: false,
            modalTitle: '',
            selectProject: '',
            projectList: [],
            isTb: false,
            modelType: 1,
            modelTitle: '',
            modelContent: '',
            tipModel: false
            // tipModel: !sessionStorage.getItem('tipModelClosed')
        };
    },

    watch: {
        filterWord(val) {
            if (val === '') {
                this.condis.originNo = '';
            }
        }
    },

    beforeMount() {
        window.sessionStorage.removeItem('StepFirst');
        window.sessionStorage.removeItem('projectIsModify');
        this.condis.isDraft = false;
        // 检查是否已关闭过提示框
        // this.tipModel = !sessionStorage.getItem('tipModelClosed');
    },
    beforeDestroy() {
        if (this.timerId) {
            clearTimeout(this.timerId);
        }
        if (this.timeOut) {
            clearTimeout(this.timeOut);
        }
    },
    mounted() {
        const cliqueNo1 = cliqueNoData;
        this.isTb = cliqueNo1.indexOf(Cookies.getJSON('cliqueNo').toString()) > -1;
        this.getChannelList();
        this.getParams();
        this.getAllOrganList();
        const supplierFun = JSON.parse(window.localStorage.getItem('supplierFunction'));
        if (supplierFun.project1 > -1) {
            this.columns12.splice(2, 0, {
                title: '计划单号',
                key: 'projectId',
                minWidth: 180
            });
        }
        this.projectStatus = supplierFun.project1 > -1 ? '1' : '0';
        this.quotationStatus = supplierFun.quotation > -1 ? '1' : '0';
    },

    methods: {
        openProject() {
            if (this.projectStatus !== '1' && this.quotationStatus === '1') {
                this.$router.push({
                    path: '/index/manualBuild',
                    query: {
                        quotation: this.quotationStatus,
                        type: 'home'
                    }
                });
            } else {
                this.modalTitle = '选择计划';
                this.getMyProjects();
                this.openProjectModal = true;
            }
        },
        // 获取计划
        getMyProjects() {
            this.$apollo.query({
                query: getMyProjects,
                context: { useApi1: false },
                variables: {
                    cliqueNo: Cookies.getJSON('cliqueNo').toString(),
                    supplierNo: Cookies.getJSON('USER-INFO').supplierNo
                },
                fetchPolicy: 'network-only'
            }).then(res => {
                const result = res.data.getMyProjects;
                result.data.forEach(item => {
                    item.label = item.projectId;
                    item.value = item.projectId;
                });
                this.projectList = result.data;
            });
        },
        // 同步计划
        resetData(originId) {
            this.$apollo.mutate({
                mutation: updateOriginalSync,
                variables: {
                    originNo: originId
                }
            }).then(res => {
                const data = res.data.updateOriginalSync;
                if (data && data.code === 200) {
                    this.$setNotice('同步成功');
                    this.getReceiptsList();
                } else {
                    this.$Notice.open({
                        title: '提示',
                        desc: data.message,
                        duration: 10
                    });
                }
            }).catch(error => {
                if (error) {
                    this.$setNotice('服务繁忙，同步失败');
                }
            });
        },
        submitProject() {
            if (this.projectStatus !== '1' && this.quotationStatus === '1') {
                this.$router.push({
                    path: '/index/manualBuild',
                    query: {
                        quotation: this.quotationStatus,
                        type: 'home'
                    }
                });
            } else {
                if (this.selectProject) {
                    this.$router.push({
                        path: '/index/modelBuild',
                        query: {
                            projectId: this.selectProject,
                            type: 'history'
                        }
                    });
                } else {
                    this.$setNotice('请选择计划');
                }
            }
        },
        // 结算渠道
        getChannelList() {
            this.$apollo.query({
                query: getAllSettleChannel,
                variables: {
                    cliqueNo: Cookies.getJSON('cliqueNo').toString(),
                    all: 1
                },
                fetchPolicy: 'network-only'
            }).then(res => {
                const result = res.data.getAllSettleChannel;
                const arr = [{
                    label: '全部',
                    value: 'D00'
                }];
                result.data.forEach(item => {
                    item.label = item.name;
                    item.value = item.alias;
                });
                this.settleChannelList = arr.concat(result.data);
            });
        },
        // 获取查询参数
        getParams() {
            const receiptVars = JSON.parse(window.sessionStorage.getItem('receiptList'));
            if (receiptVars) {
                this.condis = receiptVars.condis;
                this.department = receiptVars.receipDepartment;
                this.filterWord = receiptVars.condis.originNo;
                this.settleChannel = receiptVars.condis.settleChannel;
                if (receiptVars.condis.destroyStatus) {
                    this.single = receiptVars.condis.destroyStatus;
                }
                if (receiptVars.condis.originStatus) {
                    this.completeIndex = receiptVars.condis.originStatus;
                }
                this.getReceiptsList();
                window.sessionStorage.removeItem('receiptList');
            } else {
                this.getReceiptsList();
            }
        },

        // 获取单据列表
        getReceiptsList() {
            this.condis.isDraft = false;
            this.$apollo.query({
                query: selectAllOriginalInfo,
                variables: {
                    condi: this.condis,
                    cliqueNo: Cookies.getJSON('cliqueNo').toString()
                },
                fetchPolicy: 'network-only'
            }).then(res => {
                const data = res.data.selectAllOriginalInfo;
                if (data && data.code === 200) {
                    this.totalList = data.total;
                    this.receiptData = data.data;
                    // // 总量 && 总价赋值 默认为0
                    this.orderAllCount = data.totalCount || 0;
                    this.orderAllPrice = data.totalPrince || 0;
                    this.$setNotice('列表查询成功');
                    this.checkLoading = false;
                } else {
                    this.$setNotice(data.message);
                }
            });
        },

        // 获取部门列表
        async getAllOrganList() {
            if (this.$store.state.organs.length) {
                this.departmentData = this.$store.state.organs;
                clearTimeout(this.timeOut);
            } else {
                clearTimeout(this.timeOut);
                this.timeOut = setTimeout(() => {
                    this.getAllOrganList();
                }, 3000);
            }
        },

        // 选中部门
        getCascader(val) {
            this.condis.organNo = val[val.length - 1] || '';
        },

        // 获取格式化日期 && 开始日期
        getFormatStartDate(date) {
            this.condis.startTime = date;
        },

        // 结束日期
        getFormatEndDate(date) {
            this.condis.endTime = date;
        },

        // 单号查询
        search() {
            if (this.filterWord) {
                this.condis.originNo = this.filterWord;
                delete this.condis.startTime;
                delete this.condis.endTime;
                delete this.condis.organNo;
                this.getReceiptsList();
            } else {
                this.$setNotice('搜索内容不能为空');
            }
        },

        // data 中 option2 调用
        getTimeBegin() {
            return Date.parse(this.startDate);
        },

        // 页码变化时回调
        getChangePageNum(val) {
            this.condis.pageNumber = val;
            this.getReceiptsList();
        },

        // 分页显示条数改变
        getChangePageSize(val) {
            this.condis.pageSize = val;
            this.getReceiptsList();
        },

        // 查看详情， 参数传原始单号
        checkReceiptDetail(row) {
            const obj = {
                condis: this.condis,
                receipDepartment: this.department
            };
            window.sessionStorage.setItem('receiptList', JSON.stringify(obj));
            this.$router.push({
                path: '/index/checkDetail',
                query: {
                    origin: row.originNo
                }
            });
        },

        // 查询状态
        getCompleteState(val) {
            if (val !== 0) {
                this.condis.originStatus = val;
            } else {
                delete this.condis.originStatus;
            }
        },
        getSettleChannel(val) {
            if (val === 'D00') {
                delete this.condis.settleChannel;
            } else {
                this.condis.settleChannel = val;
            }
        },
        // 包含作废
        singleChange(val) {
            if (val) {
                delete this.condis.destroyStatus;
            } else {
                this.condis.destroyStatus = 1;
            }
        },

        // 导出xlsx， 初始化参数
        exportExls() {
            this.exportLoading = true;
            let queryVars = Object.assign({}, this.condis);
            let cliques = Cookies.getJSON('cliqueNo').toString();
            const len = Math.ceil(this.totalList / 500);
            queryVars.pageSize = 500;
            queryVars.pageNumber = 1;
            this.getExlsData(queryVars, cliques, len);
        },

        // 导出列表 数据循环获取
        getExlsData(query, clique, length) {
            this.$apollo.query({
                query: selectAllOriginalInfo,
                variables: {
                    condi: query,
                    cliqueNo: clique
                },
                fetchPolicy: 'network-only'
            }).then(res => {
                const data = res.data.selectAllOriginalInfo;
                if (data && data.data && data.code === 200) {
                    this.exportData = this.exportData.concat(data.data);
                    if (query.pageNumber <= length) {
                        query.pageNumber += 1;
                        this.getExlsData(query, clique, length);
                    } else {
                        if (this.exportData.length) {
                            document.querySelector('#Elsx-download .ivu-table-tip tbody td span').innerText = ' ';
                            // 模板下载，文件名可自定义
                            factory().excelExport({
                                'src_id': 'Elsx-download',
                                'type': 'table',
                                'show_header': true
                            }, '单据列表');
                            this.exportLoading = false;
                            this.$setNotice('导出成功');
                            this.timerId = setTimeout(() => {
                                this.exportData = [];
                            }, 3000);
                        } else {
                            this.exportLoading = false;
                            this.$setNotice('导出失败，请刷新重试');
                        }
                    }
                } else {
                    this.exportLoading = false;
                    this.$setNotice(data.message);
                }
            });
        },

        // 查询列表
        checkList() {
            this.checkLoading = true;
            this.condis.pageNumber = 1;
            this.getReceiptsList();
        },

        // 订单删除
        removeNo(type, id) {
            this.modelType = type;
            this.orderId = id;
            if (type === 1) {
                this.modelTitle = '删除';
                this.modelContent = `确定要删除原始单据${id}吗?`;
            } else if (type === 2) {
                this.modelTitle = '撤回';
                this.modelContent = `确定要撤回原始单据${id}吗?`;
            }
            this.model = true;
        },
        submit() {
            if (this.modelType === 1) {
                this.$apollo.mutate({
                    mutation: deleteOriginalInfo,
                    variables: {
                        originNo: this.orderId
                    }
                }).then(res => {
                    const data = res.data.deleteOriginalInfo;
                    if (data && data.code === 200) {
                        this.model = false;
                        this.$setNotice('单据删除成功');
                        this.getReceiptsList();
                    }
                }).catch(error => {
                    this.$setNotice(error.message);
                });
            } else if (this.modelType === 2) {
                this.$apollo.mutate({
                    mutation: rejectOriginalInfo,
                    variables: {
                        originNo: this.orderId
                    }
                }).then(res => {
                    const data = res.data.rejectOriginalInfo;
                    if (data && data.code === 200) {
                        this.model = false;
                        this.$setNotice('单据撤回成功');
                        this.getReceiptsList();
                    }
                }).catch(error => {
                    this.$setNotice(error.message);
                });
            }
        },
        // 重新修改
        revisionNo(row) {
            this.$router.push({
                path: '/index/manualBuild',
                query: {
                    originNo: row.originNo,
                    projectId: row.projectId,
                    modify: 1,
                    isLocked: row.isLocked ? '1' : '2'
                }
            });
        },
        rowClassName(row, index) {
            if (row.destroyOriginNo) {
                return 'demo-table-info-row';
            }
            return '';
        },
        closeTipModel() {
            this.tipModel = false;
            sessionStorage.setItem('tipModelClosed', 'true');
        }
    }
};
</script>

<style scoped lang="stylus">

@import '../assets/stylus/views/receipt-list.styl'
.history-order
    font-size: 14px;
    padding: 0 11px;
    .text-title
        padding-bottom: 4px;
    .text-space
        text-indent: 26px;
        line-height: 26px;
        span
            color: #2d8cf0;
            text-indent: 0;
            font-size: 16px;
            display: inline-block;
</style>



// WEBPACK FOOTER //
// src/views/ReceiptsList.vue